import React, { Component, Fragment } from "react";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getShiftsByProjectId, deleteShift } from "../actions/shiftActions";

import { Button } from "@material-ui/core";

import DataListWithSearchFilter from "./DataListWithSearchFilter";
import moment from "moment";

let credentials = JSON.parse(localStorage.getItem("credentials"));

class ProjectShiftList extends Component {
  state = {
    shifts: [],
  };

  componentDidMount() {
    this.refreshData();
  }

  deleteShift(shiftId) {
    this.props.deleteShift(shiftId).then(() => {
      this.setState({
        shifts: this.state.shifts.filter((s) => s.id != shiftId),
      });
    });
  }

  refreshData = () => {
    this.setState({ shifts: [] });

    this.props.getShiftsByProjectId(this.props.projectId).then((shifts) => {
      this.setState({ shifts });
    });
  };

  render() {
    return (
      <Fragment>
        <Button variant="contained" color="primary" onClick={this.refreshData}>
          Zoek
        </Button>

        <DataListWithSearchFilter
          data={this.state.shifts.map((shift) => {
            return {
              id: shift.id,
              title: `Dienst #${shift.id}`,
              subtitle: `${moment(shift.beginDatetime).format(
                "DD-MM-YYYY HH:mm",
              )} tot ${moment(shift.endDatetime).format("DD-MM-YYYY HH:mm")}`,
              onClick: () => (window.location.href = `/shift/${shift.id}`),
              ctxMenu: [
                {
                  label: "Wijzigen",
                  action: () =>
                    (window.location.href = `/shift/${shift.id}/update`),
                },
                {
                  label: "Dupliceren",
                  action: () =>
                    (window.location.href = `/shift/${shift.id}/duplicate`),
                },
                {
                  label: "Verwijderen",
                  action: () => this.deleteShift(shift.id),
                  confirm: true,
                  hide: !credentials.user.isAdmin,
                },
              ],
            };
          })}
          isFetching={this.props.isFetching}
          successMessage={this.props.successMessage}
          errorMessage={this.props.errorMessage}
        />
      </Fragment>
    );
  }
}

ProjectShiftList.propTypes = {
  projectId: PropTypes.string.isRequired,
  getShiftsByProjectId: PropTypes.func.isRequired,
  deleteShift: PropTypes.func.isRequired,
  successMessage: PropTypes.string,
  errorMessage: PropTypes.any,
  isFetching: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  successMessage: state.shift.deleteShift.successMessage,
  errorMessage: state.shift.deleteShift.errorMessage,
  isFetching:
    state.shift.getShiftsByProjectId.isFetching ||
    state.shift.deleteShift.isFetching,
});

export default connect(mapStateToProps, { getShiftsByProjectId, deleteShift })(
  ProjectShiftList,
);



// WEBPACK FOOTER //
// ./src/components/ProjectShiftList.js